import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {createHead} from '@vueuse/head'
import GoogleSignInPlugin from "vue3-google-signin";

import "@fortawesome/fontawesome-free/css/all.min.css";
//import '@fortawesome/fontawesome-free/css/solid.min.css';

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'; 
import { createPinia } from 'pinia';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "../src/assets/styles/custom.scss";

// import "../src/assets/js/bootstrap.bundle.min.js"

import EN from './Locale/en.json'
import AR from './Locale/ar.json'
import { createI18n } from 'vue-i18n'

// Get stored language and direction, or fall back to defaults
const storedLanguage = localStorage.getItem('language') || 'ar';
const storedDirection = localStorage.getItem('direction') || 'rtl';
const pinia = createPinia()
// Create the i18n instance
const i18n = createI18n({
  locale: storedLanguage,
  globalInjection: true,
  messages: {
    en: EN,
    ar: AR,
  }
});

// Set document direction based on the stored direction
document.body.dir = storedDirection;

// Save the default language and direction if they are not in localStorage
if (!localStorage.getItem('language')) {
  localStorage.setItem('language', 'ar');
}
if (!localStorage.getItem('direction')) {
  localStorage.setItem('direction', 'rtl');
}


const head = createHead();

createApp(App).component('VueDatePicker', VueDatePicker).use(pinia).use(head).use(i18n).use(store).use(router).use(GoogleSignInPlugin, {
  clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
  popupType: 'window'
}).mount('#app');
